import { DispDepositType } from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構への提出確認",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText:
      "退職手当金の振込先金融機関を登録し、「次へ」ボタンを押してください。",
  },
  {
    keyword: "retireeName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "振込先金融機関",
    keyword: "bankSelect",
    type: "bankSearch",
    requiredIcon: true,
  },
  {
    title: "金融機関コード",
    keyword: "bankCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "金融機関名",
    keyword: "bankName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店コード",
    keyword: "branchCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店名",
    keyword: "branchName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "預金種目",
    keyword: "depositType",
    type: "radio",
    radioPropsList: TkGetCodeList(DispDepositType),
    requiredIcon: true,
    setDefaultValue: DispDepositType["普通"],
    disabled: true,
  },
  {
    title: "口座番号",
    keyword: "accountNo",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
  },
  {
    title: "口座名義人（半角ｶﾀｶﾅ）",
    keyword: "accountNameKana",
    type: "name",
    requiredIcon: true,
    useFurigana: true,
    convertToHalfwidth: true,
    convertBankFormat: true,
    hafWidth: true,
  },
];

const schema = {
  bankSelect: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  depositType: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  accountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "7"),
    },
  },
  accountNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^([ｱ-ﾝｦ0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
};

export { steps, fakeTableList, schema };
